import { apiCallWrapper,SelectOptionModel } from 'traveldesk-ui'
import { TourImportModel } from '../pages/TourImport/TourImportModel'

export default class ExternalIntegrationsApiService {
    public static async getApiIntegrations(dispatch: any) {
        return await apiCallWrapper<SelectOptionModel[]>('/api/externalintegrations', 'GET', dispatch)
    }
    public static async getExternalTours(dispatch: any, apiIntegrationId: string) {
        return await apiCallWrapper<SelectOptionModel[]>('/api/externalintegrations/tours?apiProviderId=' + apiIntegrationId, 'GET', dispatch)
    }
    public static async getExternalTour(dispatch: any, tourId: string, apiIntegrationId: string) {
        return await apiCallWrapper<TourImportModel>(`/api/externalintegrations/tours/${tourId}?apiProviderId=${apiIntegrationId}`, 'GET', dispatch)
    }
}